import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import PolaroidCreatorPage from './PolaroidCreatorPage';
import PolaroidCreatorSettingsPage from './PolaroidCreatorSettingsPage';
import PolaroidCreatorRoutes from './PolaroidCreatorRoutes';

const manifest = {
  id: 'polaroid-creator',
  nameKey: 'extensions.polaroid_creator.name',
  descriptionKey: 'extensions.polaroid_creator.description',
  icon: PhotoCameraOutlinedIcon,
  route: '/polaroid-creator',
  menuItem: {
    labelKey: 'polaroid_creator.menu',
    basePath: '/polaroid-creator',
    children: [
      { labelKey: 'polaroid_creator.menu_creator', path: '/polaroid-creator', end: true },
      { labelKey: 'polaroid_creator.menu_settings', path: '/polaroid-creator/settings' },
    ],
  },
  nestedRoutes: {
    Layout: PolaroidCreatorRoutes,
    routes: [
      { index: true, Component: PolaroidCreatorPage, titleKey: 'polaroid_creator.menu_creator' },
      { path: 'settings', Component: PolaroidCreatorSettingsPage, titleKey: 'polaroid_creator.settings_title' },
    ],
  },
  requiredExtensions: [],
  Page: PolaroidCreatorPage,
};

export default manifest;
